import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import { discountConditionsType } from 'types/basketQuery.type';

import { usePrevious } from 'app/utils/hooks';
import { validatePromocode } from 'app/utils/promocode.utils';
import { UIInput } from 'app/components/ui';

import { analyticService } from 'global/services';
import { locales } from './basket-check.locales';


const noop = () => { };


export const BasketCheckPromocodeForm = ({
    discountConditions,
    applyPromocodeHandler,
    promocode = '',
    locale = 'ru',
    defaultLabel = '',
    heightType = 'large',
    showConfirmedLabel = false,
    setIsWelcomeDiscountShown = noop,
    hasSubmitBtn = false,
    isBoxPage = false,
}) => {
    const l = locales[locale];

    const [inputValue, setInputValue] = useState('');

    const [conditionState, setCondition] = useState({
        label: '',
        uiState: 'submit',
    });

    const prevInputValue = usePrevious(inputValue);

    const isValueChange = useMemo(
        () => (prevInputValue !== inputValue), [prevInputValue, inputValue],
    );

    /**
    * effect ставит изначаное значение промокода из url
    */
    useEffect(() => {
        if (promocode) {
            setInputValue(promocode);
        }
    }, [promocode]);

    useEffect(() => {
        const submittedPromocode = discountConditions?.promocode;
        const nextConditionState = validatePromocode(discountConditions, submittedPromocode, l, defaultLabel, showConfirmedLabel);

        setCondition(nextConditionState);
        if (nextConditionState.uiState === 'confirmed') {
            setIsWelcomeDiscountShown(false);
        }
    }, [defaultLabel, l, discountConditions, setIsWelcomeDiscountShown, showConfirmedLabel]);

    useEffect(
        () => {
            if (!hasSubmitBtn) return;
            setCondition((prev) => ({ ...prev, uiState: 'submit' }));
        },
        [inputValue, hasSubmitBtn],
    );

    const promocodeSubmitHandler = useCallback(async (e, promo = null) => {
        e?.preventDefault();
        e?.persist();

        const currentPromocode = promo || inputValue;
        setCondition({ label: '', uiState: 'validation' });
        const { promocodeConditions: nextConditions } = await applyPromocodeHandler(currentPromocode);

        const nextConditionState = validatePromocode(nextConditions, currentPromocode, l, defaultLabel, showConfirmedLabel);
        setCondition(nextConditionState);
    }, [applyPromocodeHandler, inputValue, l, defaultLabel, showConfirmedLabel]);

    const promocodeBlurHandler = useCallback((e) => {
        // if (!isValueChange) return;
        promocodeSubmitHandler(e);
    }, [promocodeSubmitHandler, isValueChange]);

    useEffect(
        () => {
            if (!isBoxPage) return;
            const params = queryString.parse(window.location.search);
            const promocodeFromUrl = params?.promo_code;
            if (promocodeFromUrl) {
                promocodeSubmitHandler(null, promocodeFromUrl);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isBoxPage],
    );

    return (
        <form
            onSubmit={promocodeSubmitHandler}
        >
            <UIInput
                onChangeHandler={setInputValue}
                inputValue={inputValue}
                onSubmitHandler={promocodeSubmitHandler}
                onBlurHandler={promocodeBlurHandler}
                uiState={conditionState.uiState}
                label={conditionState.label}
                heightType={heightType}
                isValueChange
                buttonType={conditionState.uiState}
                initialLabel={false}
            />
        </form>
    );
};

BasketCheckPromocodeForm.propTypes = {
    promocode: PropTypes.string,
    discountConditions: PropTypes.shape(discountConditionsType).isRequired,
    applyPromocodeHandler: PropTypes.func.isRequired,
    locale: PropTypes.string,
    defaultLabel: PropTypes.string,
    showConfirmedLabel: PropTypes.bool,
    heightType: PropTypes.oneOf(['large', 'medium', 'small']),
    setIsWelcomeDiscountShown: PropTypes.func,
    hasSubmitBtn: PropTypes.bool,
};


